import { Button, Flex, tokens } from "shared/components/Spor";
import colors from "shared/theme/colors";
import styled, { css } from "styled-components";

const gridIconColumnWidth = tokens.default.size.spacing[3];
const gridTimeColumnWidth = "94px";
const gridColumnGap = tokens.default.size.spacing[1.5];
const gridHorizontalPadding = tokens.default.size.spacing[3];

const busStopGridRowLayout = css`
  display: grid;
  grid-template-columns:
    ${gridIconColumnWidth} minmax(0, 1fr)
    ${gridTimeColumnWidth} ${gridTimeColumnWidth};
  column-gap: ${gridColumnGap};
  min-width: 0;
`;

export const BusStopGrid = styled.div`
  width: 100%;
  min-width: 0;
  overflow: hidden;
`;

export const BusStopEditButton = styled(Button)`
  && {
    position: absolute;
    top: ${tokens.default.size.spacing[1]};
    right: ${tokens.default.size.spacing[1]};
  }
  opacity: 0.4;
`;

export const BusStopIconBackground = styled(Flex)`
  position: relative;
  z-index: 1;
`;

export const BusStopGridRow = styled.div<{ $isCurrentStop?: boolean }>`
  ${busStopGridRowLayout}
  padding: 16px ${gridHorizontalPadding};
  background-color: ${({ $isCurrentStop, theme }) =>
    $isCurrentStop ? colors.teal700 : theme.colorBackgroundSecondary};
  position: relative;

  ${BusStopIconBackground} {
    background-color: ${({ $isCurrentStop, theme }) =>
      $isCurrentStop ? colors.teal700 : theme.colorBackgroundSecondary};
  }

  &:hover {
    background-color: ${({ $isCurrentStop, theme }) =>
      $isCurrentStop ? colors.teal600 : theme.colorBackgroundTertiary};

    ${BusStopIconBackground} {
      background-color: ${({ $isCurrentStop, theme }) =>
        $isCurrentStop ? colors.teal600 : theme.colorBackgroundTertiary};
    }

    ${BusStopEditButton} {
      opacity: 1;
    }
  }
`;

export const BusStopGridHeader = styled.div`
  ${busStopGridRowLayout}
  padding: ${tokens.default.size.spacing[1]}
    ${gridHorizontalPadding};
  background-color: ${({ theme }) => theme.colorOutlineCore};
`;

export const BusStopGridBody = styled.div`
  > ${BusStopGridRow}:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  }
`;

export const BusStopGridCell = styled.div`
  min-width: 0;
`;
